var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8PlusMath50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.88,25.01c0,2.12-1.72,3.84-3.85,3.84H28.85V42.03c0,2.13-1.72,3.85-3.859,3.85 c-2.12,0-3.84-1.72-3.84-3.85V28.85H7.97c-2.13,0-3.85-1.72-3.85-3.859c0-2.12,1.72-3.84,3.85-3.84h13.18V7.97 c0-2.13,1.72-3.85,3.86-3.85c2.12,0,3.84,1.72,3.84,3.85v13.18H42.03C44.16,21.15,45.88,22.87,45.88,25.01z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PlusMath50);
export default __webpack_public_path__ + "static/media/icons8-plus-math-50.a0b28361182e3fde4c7dcea2fbf96c2e.svg";
export { ForwardRef as ReactComponent };